<template>
    <el-container class="main-container">
      <el-header class="title">
        <img src="../assets/logo.png" class="title-img"/>
        <el-col :span="18">润泽园区管理系统</el-col>
        <el-col :span="10" class="titleRight">
           <!--<img src="../assets/logo.png" class="title-img"/>-->
          <div class="mainHead-role">
            <div class="mainHead-role-left">
            <div class="mainHead-role-title">
              <span class="user-name">欢迎您，{{userName}}</span>
              <!--<span class="user-name">欢迎您，哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈</span>-->
              <span class="mainHead-role-admin">{{roleName}}</span>
            </div>
            <div class="mainHead-role-time">
              上次登录时间:{{lastTime}}
            </div>
            </div>
            <div class="mainHead-role-right arrowDown">
              <el-tooltip placement="top"  effect="light">
                <div slot="content" >
                  <img src="../assets/images/logOut.png" class="logout-img"/>
                  <el-button type="text" @click="logout()" class="logout-span">退出</el-button>
                </div>
                <i class="el-icon-arrow-down el-icon--right">

                </i>
              </el-tooltip>

            </div>
          </div>

        </el-col>
      </el-header>
      <el-container class="content-container">
        <el-aside width="180px" style="min-width: 180px">
          <el-menu mode="vertical" @select="handleSelect" @open="handleOpen" @close="handleClose"
                   background-color="#333"
                   text-color="#fff"
                   active-text-color="#7acd82"
                   :collapse="collapse"
                   style="width:180px;"
                   :default-active="activeMenu"
          >
            <div v-for="(item,i) in menu" :key="i">
                <div v-if="item.children">
                  <el-submenu :index="String(i)">
                    <template slot="title">
                      <!--<img :src="item.icon"/>-->
                      <i :class="item.menuIcon "></i>
                      <span>{{item.name}}</span>
                    </template>
                    <div v-for="(subItem,index) in item.children" :key="index">
                      <div v-if="subItem.children">
                        <el-submenu :index="subItem.name">
                        <template slot="title">{{subItem.name}}</template>
                        <el-menu-item v-for="(sub, subIndex) in subItem.children" :index="sub.path" :key="subIndex" @click="menuItemClick(sub.name,sub.path)">{{sub.name}}</el-menu-item>
                        </el-submenu>
                      </div>
                      <div v-else>
                        <el-menu-item  :index="subItem.path"  @click="menuItemClick(subItem.name,subItem.path)">
                          {{subItem.name}}
                        </el-menu-item>
                      </div>
                    </div>
                  </el-submenu>
                </div>
                <div v-else>
                  <el-menu-item :key="item.name" :index="item.path" @click="menuItemClick(item.name,item.path)">
                    <!--<img :src="item.icon"/>-->
                    <i :class="item.menuIcon"></i>
                    <span slot="title">{{item.name}}</span>
                  </el-menu-item>
                </div>
            </div>
            <div>
              <div>
                  <el-submenu>
                    <template slot="title">
                      <i class="el-icon-s-ticket"></i>
                      <span>促销活动</span>
                    </template>
                    <div>
                      <div>
                        <el-menu-item  index="/main/consumerCoupon"  @click="menuItemClick('消费券','/main/consumerCoupon')">
                         消费券
                        </el-menu-item>
                      </div>
                    </div>
                  </el-submenu>
                </div>
            </div>
          </el-menu>
        </el-aside>
        <el-main class="main">
          <custom-tabs class="cus-tab"></custom-tabs>
        </el-main>
      </el-container>
    </el-container>
</template>

<script>
import { logout } from '@/api/login'
import { getCookie } from '@/utils/common';
import { mainTime} from '@/utils';
import { toTreeData } from '@/utils';
import CustomTabs from '../components/Tab.vue'
import bus from '@/utils/EventBus'
//import '../assets/icon/iconfont.css'
export default {
  components: {CustomTabs},
  name: "",
  props: [""],
  data() {
    return {
      menu: [],
      collapse: false,
      activeMenu:'',
      userName:'',
      roleName:'',
      lastTime:'',
      tabMap:new Map(),
      out: false,
    };
  },
  mounted(){
    this.activeMenu = this.$route.path;
    if(this.tabMap.size == 0){
      this.menuItemClick(this.$route.name,this.activeMenu)
    }
    this.userName = getCookie('userName');
    this.roleName = getCookie('roleName');
    let lastTime = getCookie('lastLoginTime');
    this.lastTime = mainTime(lastTime);
    bus.$on('activeMenu',()=>{
      this.activeMenu = this.$route.path;
    })
    bus.$on('mainMsg', (msg) => {
      this.$message.error(msg)
    })
  },
  updated(){

  },
  methods: {
    async logout () {

      await logout().then(res => {

      }).catch(err => {

      });
      this.$router.push('/');
      this.$store.commit('REMOVE_ALL_COOKIES');
      this.$notify({
        title: '退出成功',
        type: 'success',
        duration: 1000,
        showClose: false,
      });
    },
    handleSelect(index, indexPath, indexTitle) {
      this.$router.push(index);

    },
    menuItemClick(name,path){
      this.tabMap.set(name,path);
      bus.$emit('add',{m:this.tabMap,n:name});

    },
    handleOpen(index) {},
    handleClose(index) {},
    MouseOver(){
      this.out = true;
    },
    MouseOut(){
      this.out = false;
    }
  },

  created() {
       if (
         !getCookie("listFirstMenu") &&
         !getCookie("listsecondMenu") &&
         !getCookie("listThreeMenu")
       ) {
         return;
       } else {
         const listFirstMenu = JSON.parse(getCookie("listFirstMenu"));
         const listSecondMenu = JSON.parse(getCookie("listsecondMenu"));
         const listThreeMenu = JSON.parse(getCookie("listThreeMenu"));
         this.menu = toTreeData(listFirstMenu,listSecondMenu,listThreeMenu);
       }

    }
};
</script>
<style lang='scss' scoped>
  .main-container{
    display: flex;
    flex-direction: column;
  }
.title{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 300px;
}
.title-img{
  width: 40px;
  height: 40px;
  align-self: center;
  margin-right: 20px;
}
.titleRight{
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.el-header{
  background-color: #7acd82;
  color: #fff;
  text-align: left;
  min-height: 70px;
}
.content-container{
  flex-grow: 1;
  /*background-color: #FF4949;*/
}
/*.el-footer {*/
  /*background-color: #7acd82;*/
  /*color: #fff;*/
  /*text-align: left;*/
  /*line-height: 60px;*/
/*}*/

.el-aside {
  background-color: #333;
  color: #333;
  text-align: center;
}

.el-main {
  background-color: #ecf0f1;
  color: #333;
  padding: 0px;
  // text-align: center;
  /*  line-height: 160px;*/
}
.mainHead-role{
  margin-left: 15px;
  height: 55px;
  display: flex;
  min-width: 237px;
  cursor: pointer;
}
.mainHead-role-right{
  flex: 1;
}
.mainHead-role-title{
  line-height: 35px;
  height: 35px;
  text-align: right;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;

  /*width: 200px;*/
}

.mainHead-role-admin{
  // display: flex;
  // flex-direction: row;
  // justify-content: center;
  // align-items: center;
  border: 1px solid #000;
  font-size: 12px;
  border-radius: 10px;
  height: 20px;
  line-height: 23px;
  padding: 2px 4px;
  margin-left: 5px;
  /*display: inline-block;*/
  // margin-left: 10px;
  // margin-top: 5px;
}

.mainHead-role-time{
  height: 20px;
  line-height: 20px;
  font-size: 13px;
  text-align: right;
}
.arrowDown{
  position: relative;
  cursor: pointer;
}
.mainHead-role:hover .dropDown{
  display: block;
}
.dropDown{
  display: none;
  position: absolute;
  width: 100px;
  height: 40px;
  top: 50px;
  left: -90px;
  background-color: #FFF;
  color: #000;
  text-align: center;
  line-height: 40px;
  border-radius: 10px;
  font-size: 13px;
  box-shadow: 3px 4px 2px rgba(0,0,0,0.3);
}
  .cus-tab{
    height: 100%;
    background-color: #fff;
  }
  .tab .el-tabs .el-tabs--top .el-tabs--border-card{
    height: 100%;
    border:1px solid transparent;
    box-shadow: 0 0 0 0 transparent;
    -webkit-box-shadow:0 0 0 0 transparent ;
  }
.logout-img{
  height: 15px;
  width: 15px;
  margin-right: 5px;
  vertical-align: middle;
}
/*.el-menu:nth-child(1){*/
  /*align-self: flex-start;*/
/*}*/

/*.el-menu{*/
  /*display: flex;*/
  /*flex-direction: column;*/
  /*justify-content: flex-start;*/
  /*align-items: flex-start;*/
/*}*/
/*.el-menu-item {*/
  /*display: flex;*/
  /*flex-direction: row;*/
  /*justify-content: flex-start;*/
  /*align-items: center;*/
  /*width: 180px;*/
/*}*/
/*.el-submenu__title{*/
  /*display: flex;*/
  /*flex-direction: row;*/
  /*justify-content: flex-start;*/
  /*align-items: center;*/
  /*width: 180px;*/
/*}*/


/*.el-submenu{*/
  /*width: 129px;*/
/*}*/
/*.el-submenu{*/
  /*width: 180px;*/
  /*display: flex;*/
  /*flex-direction: column;*/
  /*justify-content: space-between;*/
  /*align-items: flex-start;*/
/*}*/
/*.el-submenu__title{*/
  /*align-self: flex-end;*/
/*}*/
/*.el-submenu__icon-arrow.el-icon-arrow-down{*/
  /*background-color: #FF4949;*/
/*}*/
/*.el-submenu__icon-arrow {*/
  /*position: absolute;*/
  /*right: 40px;*/
/*}*/


.el-menu-item  [class^="el-icon-"] {
  /* margin-right: 15px; */
  font-size: 26px;
}
.el-submenu__title [class^="el-icon-"]{
    font-size: 26px;
  }
.user-name{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width:200px;
}


/*.el-submenu__icon-arrow{*/
  /*width: 50px;*/
  /*background-color: #FF4949;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/pages/NewMain.vue